module.exports = __webpack_public_path__ + "static/media/product_placeholder.3aca99a8.png";